import { styles } from './styles'

const AUTH_ERRORS = {
  ERR_USER_CLOSED_POPUP:
    'Oh no! Looks like you closed the authentication pop up. Please try again.',
  ERR_FETCH_OAUTH_URL:
    'An unknown error occurred. This could be due to network connectivity or an error from the authentication service.',
  SUBSCRIPTION_NOT_ACTIVE:
    "Oh no! Looks like your shopify subscription wasn't setup correctly. Please try again.",
  DEFAULT:
    'An unknown error occurred. This could be due to network connectivity or an error from the authentication service.',
}

const OauthError = ({ authErrorCode }) => {
  return (
    <div css={styles.oauthErrorContainer}>
      {AUTH_ERRORS[authErrorCode] || AUTH_ERRORS.DEFAULT}
    </div>
  )
}

export default OauthError
